import { render, staticRenderFns } from "./HeaderGalleryVue.vue?vue&type=template&id=ee2f4adc&"
import script from "./HeaderGalleryVue.vue?vue&type=script&lang=js&"
export * from "./HeaderGalleryVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports